import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=337bcfa8&scoped=true"
import script from "./registered.vue?vue&type=script&lang=js"
export * from "./registered.vue?vue&type=script&lang=js"
import style0 from "./registered.vue?vue&type=style&index=0&id=337bcfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337bcfa8",
  null
  
)

export default component.exports